import ThemeButton from "components/Buttons/ThemeButton";
import { styled } from "@mui/material";

export const Container = styled("div")<{ scale: number }>`
	font-size: 1rem;
	background-color: #fff;
	border-radius: 25px;
	position: relative;
	overflow: hidden;
	width: 21.44em;
	height: 24.8em;
	transform: scale(${(props) => props?.scale});
`;

export const Header = styled("div")<{ "data-image": string }>`
	height: 11.75em;
	width: 100%;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	background-image: url(${(props) => props["data-image"]});
	position: relative;
`;

export const Avatar = styled("img")`
	object-fit: contain;
	position: absolute;
	bottom: 0.75em;
	left: 20%;
`;

export const Tresure = styled("img")`
	object-fit: contain;
	position: absolute;
	bottom: -0.75em;
	left: 28%;
`;

export const Body = styled("div")`
	max-width: 23.25em;
	margin: 0 auto;
	padding: 1em 1.2em;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1.2em;
`;

export const Title = styled("span")`
	font-family: "Baloo";
	font-size: 1.625em;
	line-height: 1.05em;
	text-align: center;
	color: #333;
	padding: 0.2em 0.5em;
`;

export const Button = styled(ThemeButton)`
	width: 95%;
	font-size: 1.29em;
	font-weight: 700;
	height: 2.7em;
`;
